export const LayoutOne = [
    'fig-p',
    'fig-p',
    'fig-l',
    'fig-l',
    'fig-p',
    'fig-p',
    'fig-p',
    'fig-p',
    'fig-p',
    'fig-p',
    'fig-l',
    'fig-l'
];

export const LayoutTwo = [
    'fig-l',
    'fig-l',
    'fig-p',
    'fig-l',
    'fig-p',
    'fig-p'
];


// WEBPACK FOOTER //
// ./src/components/Projects/Layout.js